import { ReactNode } from 'react';

import { Box, List, ListItem, ListItemText } from '@mui/material';

export interface PropertyDetailsListItem {
  label: ReactNode;
  value: ReactNode;
}

interface PropertyDetailsListProps {
  listData: PropertyDetailsListItem[];
  /**
   * React Elements that will be placed on the right side of the title header that can be used for navigation between
   * different lists.
   */
  navigation?: ReactNode;
  children: ReactNode;
}

export const PropertyDetailsList = ({ children, listData }: PropertyDetailsListProps) => {
  return (
    <Box width="100%" display="flex" flexDirection="column">
      {children}
      <List className="property-details-list" sx={{ display: 'flex', flexWrap: 'wrap' }}>
        {listData.map((datum, index) => {
          const { label, value } = datum;

          return (
            <ListItem
              key={index}
              disableGutters
              className="property-details-list-item"
              sx={{ flexBasis: { base: '100%', md: '50%' }, p: 1 }}
            >
              <ListItemText
                primary={label}
                primaryTypographyProps={{
                  className: 'property-details-list-item-text-primary',
                  color: 'gray.500',
                  textTransform: 'uppercase',
                }}
                secondary={value}
                secondaryTypographyProps={{
                  className: 'property-details-list-item-text-secondary',
                }}
                className="property-details-list-item-text"
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  borderBottom: (theme) => `1px solid ${theme.palette.neutrals.gray}`,
                }}
              />
            </ListItem>
          );
        })}
      </List>
    </Box>
  );
};
